"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const utils_common_get_cookie_1 = __importDefault(require("@gcloud-npm/utils.common.get-cookie"));
const shouldLoadDyna = (probability = 10) => {
    let res = false;
    let probability2Apply = probability;
    if (typeof window !== "undefined") {
        const cookiesAcepted = (0, utils_common_get_cookie_1.default)("OptanonAlertBoxClosed");
        const urlParams = new URLSearchParams(window.location.search);
        let paramValue = urlParams.get("dyna");
        if (paramValue) {
            probability2Apply = parseInt(paramValue, 10);
        }
        res = cookiesAcepted ? Math.random() < probability2Apply / 100 : false;
    }
    return res;
};
exports.default = shouldLoadDyna;
//# sourceMappingURL=index.js.map